<template>
  <div class="modal fade" id="configure-igloohome-v2" aria-hidden="false" aria-labelledby="exampleGrid" role="dialog">
    <div class="modal-dialog modal-simple modal-center">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container">
            <div class="row header">
              <div class="col-8">
                <h4 class="modal-title">
                  {{ $t('account.settings.user_services_section.igloohomev2.title') }}
                </h4>
              </div>
              <div class="col-4">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="closeModal('#configure-igloohome-v2')">
                  <span aria-hidden="true" class="close-btn">&times;</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <div class="setup-successful">
                <div class="quick-tour">
                  <!-- record video here -->
                </div>
              </div>
            </div>
          </div>
          <v-loading v-bind:isLoading="loading"></v-loading>
          <div class="row-mt-15 text-center" v-if="!loading">
            <div v-if="user.igloohome_v2_accounts && user.igloohome_v2_accounts.length > 0" class="col-12">
              <p style="font-weight: bold; text-decoration: underline;">
                Comptes connectée :
              </p>
              <div v-for="account in user.igloohome_v2_accounts">
                <p class="text-muted">
                  {{ account.email }}
                </p>
              </div>
              <div style="margin-top: 20px;">
                <button type="submit" class="btn btn-primary waves-effect waves-classic btn-save" @click.prevent="refreshIgloohomeV2()" :disabled="smallLoading">
                  Rafraichir les clefs
                </button>
              </div>
            </div>
            <div v-if="user.igloohome_v2_accounts && user.igloohome_v2_accounts.length === 0" class="col-12">
              <button type="submit" class="btn btn-primary waves-effect waves-classic btn-save" @click.prevent="logIgloohomeV2()" :disabled="smallLoading">
                {{ $t('account.settings.user_services_section.igloohomev2.login') }}
              </button>
            </div>  
          </div>
        </div>
        <div class="modal-footer text-center">
          <button type="button" class="btn waves-effect waves-classic btn-cancel" @click.prevent="closeModal('#configure-igloohome-v2')" data-dismiss="modal" :disabled="smallLoading">{{ $t('button.cancel') }}</button>
          <v-loading :isLoading="smallLoading" :height="50" :width="50" :viewbox="'0 0 50 50'" :cx="25" :cy="25" :r="22" :isHeightAuto="true"></v-loading>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import mixin from "../../../mixins/mixin";
  import accountService from "../../../services/account";

  export default {
    name: "ConfigureIgloohomeV2",
    data() {
      return {
        loading: false,
        smallLoading: false
      }
    },
    props: [
      'user'
    ],
    mixins: [mixin],
    components: {
      VLoading: require('components/loading/loading.vue'),
    },
    mounted() {
    },
    methods: {
      async logIgloohomeV2() {
        this.smallLoading = true;
        await accountService.loginIgloohomeV2(this, this.apiKey);
        await this.$emit('fetchAccount');
        mixpanel.track('web.settings.services.igloohome.sync');
      },
      async refreshIgloohomeV2() {
        this.smallLoading = true;
        await accountService.refreshIgloohomeV2(this, this.apiKey);
      }
    },
    computed: {
      account: function () {
        return this.$store.state.account;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ConfigureIgloohomeV2.vue?104e08ce